export { NewsletterExtended } from './NewsletterExtended';
